import { render } from "./StatusComponent.vue?vue&type=template&id=648ca644&scoped=true"
import script from "./StatusComponent.vue?vue&type=script&lang=js"
export * from "./StatusComponent.vue?vue&type=script&lang=js"

import "./StatusComponent.vue?vue&type=style&index=0&id=648ca644&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648ca644"]])

export default __exports__